module.exports = __webpack_public_path__ + "img/info_circle.d713c656.svg";